import React, { useEffect, useState } from "react";
import { useParams, useHistory } from 'react-router-dom'
import { Table, Space, Button } from 'antd';
import { Link } from 'react-router-dom';
import firebaseDb from '../firebase';
import { doc, getDoc, collection, query, getDocs, orderBy, onSnapshot, updateDoc, where, limit, startAfter, Timestamp } from 'firebase/firestore';
import {
    Loading3QuartersOutlined,
    LeftOutlined,
    PhoneOutlined,
    SyncOutlined,
    VideoCameraOutlined,
    FileDoneOutlined
} from "@ant-design/icons";
import api from '../service/index'
import axios from 'axios';
import ExportJsonExcel from 'js-export-excel';
import { useCallback } from "react";

const ResultDetail = () => {
    let params = useParams()
    let id = params.id !== "add" ? params.id : false;
    let [data, setData] = useState([]);
    let [totalCount, setTotalCount] = useState(0)
    let [sessionId, setSessionId] = useState(0)
    let [loading, setLoading] = useState(false);
    let [answerKey, setAnswerKey] = useState(null);
    let [stream, setStream] = useState(null);

    // Pagination state
    let [currentPage, setCurrentPage] = useState(1);
    let [pageSize, setPageSize] = useState(10);
    let [lastVisible, setLastVisible] = useState(null);
    let [firstVisible, setFirstVisible] = useState(null);
    let [documentSnapshots, setDocumentSnapshots] = useState({}); // Store snapshots for each page

    const history = useHistory();

    // Get total count of documents (estimated approach for better performance)
    let getTotalCount = async () => {
        try {
            // For better performance, you can estimate the count
            // This fetches a larger sample to estimate total
            let answerRef = collection(firebaseDb, "answer/" + id + "/users");
            let answerQuery = query(answerRef, orderBy("correctAnswerCount", "desc"), orderBy("time"), limit(100));
            const snapshot = await getDocs(answerQuery);

            if (snapshot.docs.length < 100) {
                // If we got less than 100, that's the total
                setTotalCount(snapshot.docs.length);
            } else {
                // If we got 100, estimate there might be more
                // You can adjust this logic based on your needs
                setTotalCount(snapshot.docs.length + "+"); // Shows "100+"

                // Or fetch all if needed (less efficient but accurate)
                const fullQuery = query(answerRef, orderBy("correctAnswerCount", "desc"), orderBy("time"));
                const fullSnapshot = await getDocs(fullQuery);
                setTotalCount(fullSnapshot.docs.length);
            }
        } catch (error) {
            console.error('Error getting total count:', error);
            setTotalCount(0);
        }
    }

    let handleTableChange = async (pagination, filters, sorter) => {
        const { current, pageSize: newPageSize } = pagination;

        if (newPageSize !== pageSize) {
            // If page size changed, reset to page 1
            setPageSize(newPageSize);
            setCurrentPage(1);
            setDocumentSnapshots({});
            await get(1, newPageSize);
        } else {
            // Normal pagination
            setCurrentPage(current);
            await get(current, pageSize);
        }
    }

    let get = async (page = 1, size = pageSize) => {
        try {
            setLoading(true);
            // Get stream data first (only on first load)
            if (page === 1 && !stream) {
                const streamRef = doc(firebaseDb, "stream", id);
                const streamSnap = await getDoc(streamRef);
                if (streamSnap.exists()) {
                    setSessionId(streamSnap.data().sessionId);
                    setStream(streamSnap.data());
                }
                console.log("Stream Loaded ... ");
            }

            let answerRef = collection(firebaseDb, "answer/" + id + "/users");

            let answerQuery = query(
                answerRef,
                limit(size)
            );

            // Handle pagination
            if (page > 1) {
                // Check if we have the snapshot for the previous page
                const prevPage = page - 1;
                if (documentSnapshots[prevPage]) {
                    // Use the last document from previous page
                    const startAfterDoc = documentSnapshots[prevPage].lastDoc;
                    answerQuery = query(
                        answerRef,
                        orderBy("correctAnswerCount", "desc"),
                        orderBy("time"),
                        startAfter(startAfterDoc),
                        limit(size)
                    );
                } else {
                    // If we don't have the snapshot, we need to fetch from beginning
                    // This is not ideal but handles edge cases
                    const skipCount = (page - 1) * size;
                    answerQuery = query(
                        answerRef,
                        orderBy("correctAnswerCount", "desc"),
                        orderBy("time"),
                        limit(skipCount + size)
                    );
                }
            }

            const docsSnap = await getDocs(answerQuery);

            let docs = docsSnap.docs;
            console.log("Answers Length:", docs.length);
            for (const doc of docs) {
                console.log(doc.data());
            }

            // If we fetched extra documents for skipping, take only the last 'size' documents
            if (page > 1 && !documentSnapshots[page - 1]) {
                docs = docs.slice(-size);
            }

            // Store document snapshots for pagination
            if (docs.length > 0) {
                setDocumentSnapshots(prev => ({
                    ...prev,
                    [page]: {
                        firstDoc: docs[0],
                        lastDoc: docs[docs.length - 1]
                    }
                }));
            }

            let _data = [];

            // Process each answer document
            for (const document of docs) {
                try {
                    let answer = document.data();
                    let answerTime = answer.duration || answer.time || 0;
                    if (answer.userId) {
                        // Query users collection by UUID
                        const userRef = collection(firebaseDb, 'users');
                        const userQuery = query(userRef, where("uuid", "==", answer.userId));
                        const userSnaps = await getDocs(userQuery);
                        const [userSnap] = userSnaps.docs.map((doc) => {
                            return doc
                        });

                        if (userSnap && userSnap.exists()) {

                            let user = {
                                key: document.id,
                                profileImageUrl: userSnap.data().profileImageUrl || null,
                                userId: answer.userId,
                                username: [userSnap.data().name, userSnap.data().surname].filter(x => x).join(' '),
                                platform: userSnap.data().platform || null,
                                phone: userSnap.data().phone || null,
                                voipToken: userSnap.data().voipToken || null,
                                pushCode: userSnap.data().pushCode || null,
                                playerId: userSnap.data().playerId || null,
                                correctAnswerCount: answer.correctAnswerCount || 0,
                                wrongAnswerCount: answer.wrongAnswerCount || 0,
                                time: answerTime,
                            }
                            _data.push(user);
                        }
                    } else {
                        let user = {
                            key: document.id,
                            profileImageUrl: null,
                            userId: 'Unknown',
                            username: 'Anonymous User',
                            platform: null,
                            phone: null,
                            voipToken: null,
                            pushCode: null,
                            playerId: null,
                            correctAnswerCount: answer.correctAnswerCount || 0,
                            wrongAnswerCount: answer.wrongAnswerCount || 0,
                            time: answerTime,
                        }
                        _data.push(user);
                    }
                } catch (e) {
                    console.error('Error processing answer document:', e);
                    continue;
                }
            }

            console.log('Processed data:', _data);
            setData(_data);

            // Get total count only on first load
            if (page === 1) {
                await getTotalCount();
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    let getAnswerKey = useCallback(async () => {
        try {
            let questionSetId
            const streamRef = doc(firebaseDb, "stream", id);
            const streamSnap = await getDoc(streamRef);

            if (streamSnap.exists()) {
                questionSetId = streamSnap.data().questionSetId
                setStream(streamSnap.data())
            }

            if (questionSetId) {
                const response = await api.get("/rest/questionSet/getAnswers/" + questionSetId);
                setAnswerKey(response.data);
            }
        } catch (error) {
            console.error('Error fetching answer key:', error);
        }
    }, [id])


    let call = async (userData) => {
        try {
            const article = { sessionId: sessionId, user: userData };
            const response = await axios.post("https://futurelive-api.eventapp.app/rest/call", article);
            return response.data.opentokSessionId;
        } catch (error) {
            console.error('Error making call:', error);
        }
    }

    let startRecord = async () => {
        const win = window.open("https://futurelive-web.eventapp.app/?se=" + sessionId, "_blank");
        if (win) win.focus();
    }

    const exportExcel = async () => {
        try {
            setLoading(true);

            // Fetch ALL data for export (not paginated)
            let answerRef = collection(firebaseDb, "answer/" + id + "/users");
            let answerQuery = query(
                answerRef,
                orderBy("correctAnswerCount", "desc"),
                // No limit() - fetch all documents
            );

            const docsSnap = await getDocs(answerQuery);
            console.log("Exporting all answers. Total count:", docsSnap.docs.length);

            let allData = [];


            // Process each answer document
            for (const document of docsSnap.docs) {
                try {
                    let answer = document.data();
                    let answerTime = answer.duration || answer.time || 0;
                    if (answer.userId) {
                        // Query users collection by UUID
                        const userRef = collection(firebaseDb, 'users');
                        const userQuery = query(userRef, where("uuid", "==", answer.userId));
                        const userSnaps = await getDocs(userQuery);
                        const [userSnap] = userSnaps.docs.map((doc) => {
                            return doc
                        });
                        if (userSnap && userSnap.exists()) {
                            let user = {
                                key: document.id,
                                profileImageUrl: userSnap.data().profileImageUrl || null,
                                userId: answer.userId,
                                username: [userSnap.data().name, userSnap.data().surname].filter(x => x).join(' '),
                                platform: userSnap.data().platform || null,
                                phone: userSnap.data().phone || null,
                                voipToken: userSnap.data().voipToken || null,
                                pushCode: userSnap.data().pushCode || null,
                                playerId: userSnap.data().playerId || null,
                                correctAnswerCount: answer.correctAnswerCount || 0,
                                wrongAnswerCount: answer.wrongAnswerCount || 0,
                                time: answerTime,
                            }
                            allData.push(user);
                        }
                    } else {
                        let user = {
                            key: document.id,
                            profileImageUrl: null,
                            userId: 'Unknown',
                            username: 'Anonymous User',
                            platform: null,
                            phone: null,
                            voipToken: null,
                            pushCode: null,
                            playerId: null,
                            correctAnswerCount: answer.correctAnswerCount || 0,
                            wrongAnswerCount: answer.wrongAnswerCount || 0,
                            time: answerTime,
                        }
                        allData.push(user);
                    }
                } catch (e) {
                    console.error('Error processing answer document for export:', e);
                    continue;
                }
            }

            // Prepare Excel data
            var option = {};
            let dataTable = [];
            let excelData = allData; // Use all fetched data instead of paginated data

            if (excelData) {
                for (let i in excelData) {
                    if (excelData[i]) {
                        // const totalSeconds = Math.floor(excelData[i].time);
                        // const hours = Math.floor(totalSeconds / 3600);
                        // const minutes = Math.floor((totalSeconds % 3600) / 60);
                        // const seconds = Math.floor(totalSeconds % 60);
                        const seconds = excelData[i].time;
                        const minutes = Math.floor(seconds / 60);
                        const hours = Math.floor(minutes / 60);


                        let obj = {
                            'Kullanıcı Adı': excelData[i].username,
                            'Telefon Numarası': excelData[i].phone,
                            'Bitirme Süresi(HH:MM,SS)': `${hours}:${minutes < 10 ? '0' : ''}${minutes},${seconds < 10 ? '0' : ''}${seconds}`,
                            'Profil Resim Yolu': excelData[i].profileImageUrl,
                            'Doğru Sayısı': excelData[i].correctAnswerCount,
                            'Yanlış Sayısı': excelData[i].wrongAnswerCount,
                            'Platform': excelData[i].platform,
                        }
                        dataTable.push(obj);
                    }
                }
            }

            let sheetAreas = ['Kullanıcı Adı', "Telefon Numarası", 'Bitirme Süresi(HH:MM,SS)',
                'Profil Resim Yolu', 'Doğru Sayısı', 'Yanlış Sayısı', 'Platform'];

            option.fileName = stream ? stream.name || "Results" : "Results";
            option.datas = [
                {
                    sheetData: dataTable,
                    sheetName: 'sheet',
                    sheetFilter: sheetAreas,
                    sheetHeader: ['Kullanıcı Adı', "Telefon Numarası", 'Bitirme Süresi(HH:MM,SS)',
                        'Profil Resim Yolu', 'Doğru Sayısı', 'Yanlış Sayısı', 'Platform']
                }
            ];

            var toExcel = new ExportJsonExcel(option);
            toExcel.saveExcel();

            console.log(`Excel exported with ${dataTable.length} records`);

        } catch (error) {
            console.error('Error exporting to Excel:', error);
        } finally {
            setLoading(false);
        }
    }

    const loadData = useCallback(async () => {
        try {
            await getAnswerKey();
            await get(1, pageSize);
        } catch (error) {
            console.error('Error loading data:', error);
        }
    }, [id, pageSize])
    let checkAnswer = useCallback(async () => {
        if (answerKey) {
            setLoading(true)
            let answerRef = collection(firebaseDb, "answer/" + id + "/users")
            await onSnapshot(answerRef, (snapshot) => {
                snapshot.docChanges().forEach(async (change) => {
                    if (change.type === "added") {
                        let answer = { ...change.doc.data(), id: change.doc.id }
                        if (answer.correctAnswerCount === undefined) {
                            let correctAnswerCount = 0
                            let wrongAnswerCount = 0
                            let time = 0
                            if (answer.questions) {
                                for (const [key, value] of Object.entries(answerKey)) {
                                    for (const [answerK, answerV] of Object.entries(answer.questions)) {
                                        if (key === answerK) {
                                            if (value == answerV) {
                                                correctAnswerCount++
                                            } else {
                                                wrongAnswerCount++
                                            }
                                        }
                                    }
                                }
                            }
                            await updateDoc(doc(firebaseDb, "answer/" + id + "/users", change.doc.id), {
                                correctAnswerCount: correctAnswerCount,
                                wrongAnswerCount: wrongAnswerCount,
                            })
                        }
                    }
                })
            })

            setLoading(false)
        }
    }, [answerKey, id])
    // Refresh function that maintains current page
    const refreshData = async () => {
        setDocumentSnapshots({}); // Clear snapshots to force fresh fetch
        await get(currentPage, pageSize);
    }

    let columns = [
        {
            title: 'Fotograf',
            dataIndex: 'profileImageUrl',
            key: 'profileImageUrl',
            width: 100,
            render: (profileImageUrl) => {
                return (
                    <div style={{ width: '75px' }}>
                        <img
                            src={profileImageUrl || "https://futurelive-api.eventapp.app/files/avatar.png"}
                            style={{ width: '100%' }}
                            alt="Profile"
                            onError={(e) => {
                                e.target.src = "https://futurelive-api.eventapp.app/files/avatar.png";
                            }}
                        />
                    </div>
                )
            }
        },
        {
            title: 'Kullanıcı Adı',
            dataIndex: 'username',
            key: 'username',
            width: 100,
        },
        {
            title: 'Telefon Numarası',
            dataIndex: 'phone',
            key: 'phone',
            width: 150,
        },
        {
            title: 'Doğru',
            dataIndex: 'correctAnswerCount',
            key: 'correctAnswerCount',
            width: 50,
        },
        {
            title: 'Yanlış',
            dataIndex: 'wrongAnswerCount',
            key: 'wrongAnswerCount',
            width: 50,
        },
        {
            title: 'Bitirme Süresi(HH:MM,SS)',
            dataIndex: 'time',
            key: 'time',
            width: 100,
            render: (text, record) => {
                let answerTime = record.duration || record.time || 0;
                const seconds = Math.floor(answerTime);
                const minutes = Math.floor(seconds / 60);
                const hours = Math.floor(minutes / 60);
                return <p>{`${hours}:${minutes < 10 ? '0' : ''}${minutes},${seconds < 10 ? '0' : ''}${seconds}`}</p>;
            }
        },
        {
            title: '',
            key: 'action',
            fixed: 'right',
            align: 'right',
            className: 'editColumn',
            width: 150,
            render: (text, record) => (
                <Space size="small">
                    <Button
                        className="button-consultant"
                        onClick={() => call(record)}
                        icon={<PhoneOutlined />}
                    >
                        Görüşmeye Ekle
                    </Button>
                </Space>
            ),
        },
    ];

    useEffect(() => {
        if (id) {
            loadData();
        }
    }, [id, loadData]);

    useEffect(() => {
        if (id) {
            checkAnswer();
        }
    }, [id, checkAnswer]);
    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Sonuçlar"} </h1>
                </div>
                <div className="list-buttons div-buttons">
                    <Button
                        className="button4"
                        style={{ marginRight: "2px" }}
                        type="light"
                        onClick={() => exportExcel()}
                        icon={<FileDoneOutlined />}
                        size="large"
                    >
                        Rapor
                    </Button>
                    <Button
                        className="button4"
                        style={{ marginRight: "2px" }}
                        type="light"
                        onClick={() => {
                            checkAnswer();
                            refreshData();
                        }}
                        icon={<SyncOutlined />}
                        size="large"
                    >
                        Yenile
                    </Button>
                    <Button
                        className="button4"
                        style={{ marginRight: "2px" }}
                        type="light"
                        onClick={() => startRecord()}
                        icon={<VideoCameraOutlined />}
                        size="large"
                    >
                        Görüşme Başlat
                    </Button>
                    <Link to="/results">
                        <Button
                            className="button4"
                            style={{ marginRight: "2px" }}
                            type="light"
                            icon={<LeftOutlined />}
                            size="large"
                        >
                            GERİ
                        </Button>
                    </Link>
                </div>
            </div>

            <div className="table-wrap">
                <Table
                    dataSource={data}
                    columns={columns}
                    loading={{
                        spinning: loading,
                        indicator: <Loading3QuartersOutlined spin />,
                        size: "large"
                    }}
                    onChange={handleTableChange}
                    pagination={{
                        current: currentPage,
                        total: totalCount,
                        pageSize: pageSize,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                    scroll={{ x: 800 }}
                />
            </div>
        </div>
    );
};

export default ResultDetail;

